import React from 'react';
import StaticPages from '../../components/AdminNext/StaticPages';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Static pages — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <StaticPages />
      </HeadLessLayout>
    )
  };
}

export default action;
